<template>
    <div>
        <sub-menu-call-center ativo="valores" />

        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtro" :sync="true" @sync="load()" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fa fa-building fa-fw"
                            :edicao="!$store.state.user.id_unidade_operacao"
                            type="select"
                            placeholder="Todas as Unidades..."
                            :optionsList="$util.unidades_com_tags(true, true)"
                            optionsData="id_unidade_operacao"
                            v-model="filtro.id_unidade_operacao">
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input 
                            placeholder="Selecionar paciente..."
                            icon="fas fa-user"
                            type="autocomplete" 
                            optionsMode="aql"
                            service="pacientes.index"
                            optionsDisplay="search"
                            ref="info_paciente"
                            v-model="filtro.paciente" 
                            :optimized_ac="true">
                        </az-input>
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-9">
                        <az-input
                            icon="fa fa-search fa-fw" 
                            placeholder="Pesquisar..."
                            v-model="filtro.search"
                            @onEnter="load()">
                            <template v-slot:buttonposb>
                                <div>
                                    <div class="input-group-append">
                                        <span class="input-group-text bg-danger text-white" id="basic-addon2">Beta</span>
                                    </div>
                                </div>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            type="checkbox-group"
                            label="Filtrar Atendidos"
                            v-model="filtro.block_atendidos" />
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12">
                        <az-input
                            sizing="sm"
                            type="button-group"
                            :optionsList="[
                                { id: 'G', search: 'Geral' },
                                { id: 'O', search: 'Por Operadora' },
                                { id: 'U', search: 'Por Unidade' },
                                { id: 'P', search: 'Por Usuário' },
                            ]"
                            optionsData="id"
                            v-model="agrupamento" />
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-3">
            <div class="indeterminate" v-if="$store.state.loading && lista.length"></div>
            <div class="determinate" v-else></div>
        </div>

        <az-empty-state v-if="!lista.length"
            :icon="firstLoad ? 'fas fa-sync-alt' : 'fa fa-calendar-o'"
            :msg="firstLoad ? 'Buscar Marcações' : 'Nenhuma marcação identificada.'" />

        <div v-else>
            <table class="table bg-white cabecalho-fixo">
                <thead>
                    <tr>
                        <th>Data</th>
                        <th>Paciente</th>
                        <th>Procedimento</th>
                        <th class="text-right">Previsto</th>
                        <template v-if="!dados.parms.block_atendidos">
                            <th class="text-right">Atendido</th>
                        </template>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(items, grupo, igx) in lista_agrupada">
                        <tr :key="igx" v-show="agrupamento != 'G'" class="table-info" v-if="true">
                            <th colspan="3">
                                {{ grupo }}
                                <span class="badge badge-info ml-2">{{ items.length }}</span>
                            </th>
                            <th class="text-right">
                                {{ $util.formatMoeda(items.reduce((a, b) => a + ( b.dc_valor_previsto ? parseFloat(b.dc_valor_previsto) : 0 ), 0)) }}
                            </th>
                            <template v-if="!dados.parms.block_atendidos">
                                <th class="text-right">
                                    {{ $util.formatMoeda(items.filter(item => item.id_atendimento && item.ch_estado_marcacao == 'A')
                                            .reduce((a, b) => a + ( ( b.atendimento && b.atendimento.total_items ) 
                                        ? parseFloat(b.atendimento.total_items.valor_total) 
                                        : 0 ), 0)) }}
                                </th>
                            </template>
                            <th></th>
                        </tr>
                        <tr v-for="(marcacao, imx) in items" :key="'G' + igx + '.' + imx">
                            <td>
                                <a href="#" @click.prevent="editar(marcacao)" class="card-link">
                                    {{ $util.getFormatDate(marcacao.dt_inicio) }}
                                    {{ marcacao.dt_inicio.substr(11,5) }}
                                </a>
                                <div v-if="marcacao.usuario_venda" class="small text-muted">
                                    <span class="mr-1" v-if="marcacao.fl_oferta">
                                        <i class="fas fa-sun mr-2"></i>
                                    </span>
                                    {{ marcacao.usuario_venda.st_login }}
                                </div>
                                <div v-if="marcacao.id_atendimento">
                                    #{{ marcacao.id_atendimento }}
                                </div>
                            </td>
                            <td>
                                {{ marcacao.nome_paciente }}
                                <div class="small text-muted">
                                    {{ marcacao.plano.search }}
                                </div>
                            </td>
                            <td>
                                {{ marcacao.procedimento.search }}
                                <span class="badge badge-pill" v-if="marcacao.procedimento.id_classe_procedimento == 1 && marcacao.ch_tipo_consulta"
                                    :class="marcacao.ch_tipo_consulta == 'R' ? 'badge-danger' 
                                        : ( marcacao.ch_tipo_consulta == 'P' ? 'badge-info' : 'badge-warning' )">
                                    {{ marcacao.ch_tipo_consulta }}
                                </span>
                                <span class="badge badge-pill badge-primary" v-if="marcacao.outros_proc">
                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                    {{ marcacao.outros_proc }}
                                </span>
                                <div class="small text-muted">
                                    {{ marcacao.medico.st_nome_exibicao }}

                                    <span class="badge badge-light ml-2" v-if="marcacao.unidade_operacao">
                                        {{ marcacao.unidade_operacao.st_sigla }}
                                    </span>
                                </div>
                            </td>
                            <td class="text-right">
                                {{ $util.formatMoeda(marcacao.dc_valor_previsto) }}
                            </td>
                            <template v-if="!dados.parms.block_atendidos">
                                <td class="text-right">
                                    <span v-if="marcacao.atendimento && marcacao.atendimento.total_items">
                                        {{ $util.formatMoeda(marcacao.atendimento.total_items.valor_total) }}
                                    </span>
                                </td>
                            </template>
                            <td class="text-right">
                                <input type="checkbox" v-model="marcacao.status_confirmacao" v-if="marcacao.ch_estado_marcacao == 'A'" /> <!-- !marcacao.id_atendimento &&  -->
                            </td>
                        </tr>
                    </template>
                </tbody>
                <tfoot>
                    <th colspan="3">Total</th>
                    <th class="text-right">
                        {{ $util.formatMoeda(lista.reduce((a, b) => a + ( b.dc_valor_previsto ? parseFloat(b.dc_valor_previsto) : 0 ), 0)) }}
                    </th>
                    <template v-if="!dados.parms.block_atendidos">
                        <th class="text-right">
                            {{ $util.formatMoeda(lista.filter(item => item.id_atendimento && item.ch_estado_marcacao == 'A')
                                    .reduce((a, b) => a + ( ( b.atendimento && b.atendimento.total_items ) 
                                ? parseFloat(b.atendimento.total_items.valor_total) 
                                : 0 ), 0)) }}
                        </th>
                    </template>
                    <th></th>
                </tfoot>
            </table>

            <br><br><br><br><br>

            <nav class="navbar fixed-bottom navbar-light bg-light" v-if="lista.length">
                <div>
                    <span>{{ lista.filter(item => item.status_confirmacao).length }} / {{ lista.length }}</span>
                    
                    <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>

                    <span>
                        {{ $util.formatMoeda(lista.filter(item => item.status_confirmacao).reduce((a, b) => a + parseFloat(b.dc_valor_previsto), 0)) }} /
                        {{ $util.formatMoeda(lista.reduce((a, b) => a + ( b.dc_valor_previsto ? parseFloat(b.dc_valor_previsto) : 0 ), 0)) }}
                    </span>
                </div>
                <div>
                    <button type="button" class="btn btn-sm btn-primary" @click="marcar_todos()">Marcar Todos</button>
                    <az-submit color="success btn-sm ml-1" :disabled="!lista.filter(item => item.status_confirmacao).length" @click="atualizar()">
                        Recalcular
                    </az-submit>  
                </div>
            </nav>

            <pre v-if="false">{{ dados }}</pre>
        </div>

        <az-dispatch ref="dispatchModal" titulo="Recálculo de Valores Previstos" @refresh="load()" />

        <!-- Modal -->
        <div class="modal fade" id="detalheCalcModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="detalhe_calc">
                    <div class="modal-header">
                        <h5 class="modal-title">Detalhamento do Valor</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="detalhe_calc && detalhe_calc.calc_valores && detalhe_calc.calc_valores.lista2">
                            <div class="alert alert-info d-flex justify-content-between">
                                <div>Marcação: {{ detalhe_calc.id_marcacao }}</div>
                                <div v-if="detalhe_calc.id_atendimento">Atendimento: #{{ detalhe_calc.id_atendimento }}</div>
                            </div>

                            <table class="table table-sm table-hover small">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Descrição</th>
                                        <th>Tabela</th>
                                        <th>Origem</th>
                                        <th class="text-right">Qtde</th>
                                        <th class="text-right">Unitário</th>
                                        <th class="text-right">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(item, index) in detalhe_calc.calc_valores.lista2">
                                        <tr  :key="index" v-if="true">
                                            <td>#{{ item.id_procedimento }}</td>
                                            <td>{{ item.procedimento ? item.procedimento.search : '?' }}</td>
                                            <td>{{ item.id_item_tabela }}</td>
                                            <td><template v-if="item.id_proc_pai">#{{ item.id_proc_pai }}</template></td>
                                            <td class="text-right">{{ item.in_quantidade }}</td>
                                            <td class="text-right">{{ $util.formatMoeda(item.dc_valor_procedimento) }}</td>
                                            <td class="text-right">{{ $util.formatMoeda(item.dc_valor_procedimento * item.in_quantidade) }}</td>
                                        </tr>
                                        <template v-if="item.atendimento_procedimento_consumos && item.atendimento_procedimento_consumos.length">
                                            <tr v-for="(consumo, cIndex) in item.atendimento_procedimento_consumos" :key="'C' + index + '-' + cIndex">
                                                <td></td>
                                                <td>{{ consumo.search }}</td>
                                                <td>{{ consumo.id_item_tabela ? consumo.id_item_tabela : consumo.id_propria }}</td>
                                                <td><template v-if="item.id_proc_pai">#{{ item.id_proc_pai }}</template></td>
                                                <td class="text-right">{{ consumo.in_quantidade }}</td>
                                                <td class="text-right">{{ $util.formatMoeda(consumo.dc_valor_unitario) }}</td>
                                                <td class="text-right">{{ $util.formatMoeda(consumo.dc_valor_unitario * consumo.in_quantidade) }}</td>
                                            </tr>
                                        </template>
                                    </template>
                                </tbody>
                            </table>
                        </div>

                        <pre v-if="false">{{ detalhe_calc }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzDispatch from '../../util/AzDispatch.vue';
import SubMenuCallCenter from './SubMenuCallCenter.vue';

export default {
    data() {
        return { 
            filtro: { 
                periodo: 'h', 
                id_unidade_operacao: "", 
                id_medico: "", 
                block_atendidos: true, 
                paciente: "", 
            }, 
            dados: null, 
            firstLoad: true, 
            agrupamento: 'G', 
            detalhe_calc: null, 
        };       
    },

    components: {
        AzPeriodo,
        AzInput,
        AzEmptyState,
        AzSubmit,  
        AzDispatch, 
        SubMenuCallCenter, 
    },

    computed: { 
        lista: function () { 
            if ( !this.dados ) 
                return [];

            if ( !this.filtro.search )
                return this.dados.lista;

            let reg = this.$util.getregex(this.filtro.search);

            return this.dados.lista.filter(item => !this.filtro.search || reg.test(JSON.stringify(item)));
        },

        lista_agrupada: function () { 
            return _.groupBy(
                this.lista, 
                item => { 
                    switch (this.agrupamento) {
                        case 'U': return item.unidade_operacao.st_nome;
                        case 'P': return _.get(item, 'usuario_venda.pessoa.st_nome');
                        case 'O': return _.get(item, 'plano.operadora.st_operadora');
                        default: return '-';
                    }
                }
            );
        },
    },

    methods: { 
        marcar_todos () { 
            let status = !this.lista.filter(item => !item.id_atendimento && item.ch_estado_marcacao == 'A')
                .find(item => item.status_confirmacao);

            this.lista.filter(item => !item.id_atendimento && item.ch_estado_marcacao == 'A')
                .forEach(item => item.status_confirmacao = status);
        },

        load() { 
            this.firstLoad = false;
        
            this.$util.load(this, { 
                service: 'marcacoes', 
                func: 'valores', 
                parms: { 
                    ...this.filtro, 
                }
            });
        },

        atualizar() {
            let lista = this.lista.filter(item => item.status_confirmacao)
                .map(item => { 
                    return { 
                        id_marcacao: item.id_marcacao
                    };
                });

            if ( lista.length == 1 ) { 

                this.$util.atualizar(this, { 
                    service: 'marcacoes',
                    func: 'recalc_valores',
                    dados: { 
                        lista: lista
                    }, 
                    reload: true, 
                    toast: true, 
                    callback: res => {
                        this.detalhe_calc = _.first(res); 

                        if ( !this.detalhe_calc ) { 
                            this.$toast.add({ 
                                severity: 'warn',
                                summary: 'Atenção',
                                detail: 'Nenhum valor identificado.'
                            });
                        } else { 
                            $('#detalheCalcModal').modal('show');
                        }

                    }
                }); 

            } else { 

                this.$refs.dispatchModal.executar_chunck(
                    "marcacoes",
                    "recalc_valores",
                    lista,
                    "lista",
                    {},
                    50
                );

            }
        },

        editar(marcacao) { 
            this.$root.editar_marcacao(marcacao.id_marcacao, () => { 
              this.$emit('refresh');
            });
        }
    },

    mounted() { 
        this.$store.commit("setBreadcrumb", [
            { name: "Call Center", path: "/call-center" },
            { name: "Valores", path: "/call-center/valores" }
        ]);        
    }
}
</script>
